import * as React from 'react';
import { FormGroup, Label, Paragraph } from './styles/common';
import getFieldId from './getFieldId';

export function FormInputDate({
  label, paragraph, registration, valid, error, minDate, maxDate, value, onChange, hint,
}) {
  const fieldId = getFieldId(undefined, registration);
  const errorId = error ? `${fieldId}-error` : undefined;

  if (registration === undefined) {
    const handleChange = (e) => {
      onChange(e.target.value);
    };

    return (
      <FormGroup>
        {label !== undefined && <Label htmlFor={fieldId}>{label}</Label>}
        {paragraph !== undefined && <Paragraph>{paragraph}</Paragraph>}
        <input
          id={fieldId}
          className={`form-control ${error ? 'is-invalid' : ''} ${valid ? 'is-valid' : ''}`}
          type="date"
          lang="it-IT"
          min={minDate}
          max={maxDate}
          value={value}
          onChange={handleChange}
          aria-invalid={error ? 'true' : undefined}
          aria-describedby={errorId}
        />
        <div className="invalid-feedback" id={errorId}>{error}</div>
        {hint && <p className="form-input-hint">{hint}</p>}
      </FormGroup>
    );
  }
  // A native date input in onTouched mode only validates on blur — picking a
  // date from the picker leaves any error showing until the field loses
  // focus. RHF's onChange/onBlur are one handler keyed on event.type; fire a
  // blur-typed synthetic event right after the change so the state updates
  // immediately. (Mirrors FormInputSelect.)
  const handleRegistrationChange = (e) => {
    registration.onChange(e);
    registration.onBlur({
      type: 'blur',
      target: { name: registration.name, value: e.target.value },
    });
  };

  return (
    <FormGroup>
      {label !== undefined && <Label htmlFor={fieldId}>{label}</Label>}
      {paragraph !== undefined && <Paragraph>{paragraph}</Paragraph>}
      <input
        id={fieldId}
        className={`form-control ${error ? 'is-invalid' : ''} ${valid ? 'is-valid' : ''}`}
        type="date"
        lang="it-IT"
        min={minDate}
        max={maxDate}
        {...registration}
        onChange={handleRegistrationChange}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={errorId}
      />
      <div className="invalid-feedback" id={errorId}>{error}</div>
      {hint && <p className="form-input-hint">{hint}</p>}
    </FormGroup>
  );
}
